import {EventType, PartEvent} from '../../models/PartEvent';
import {Block} from '../../models/Block';
import {AnchorOffsetType, AnchorPoint} from '../../models/Anchor';
import {Expander} from '../../business/expanded_parts/Expander';

export function partEventsToApiEvents(
    blocks: Block[],
    events: PartEvent[],
): Array<{
    part_number: number;
    type: EventType;
    key: any;
    value: any;
    anchor_point: AnchorPoint;
    anchor_offset_type: AnchorOffsetType;
    anchor_offset_value: number;
}> {
    const expandedParts = new Expander().expand(blocks);
    return events.map((event) => ({
        part_number:
            1 + expandedParts.findIndex((expandedPart) => expandedPart.__uuid === event.anchor.__expandedPartUuid),
        type: event.type,
        key: event.key,
        value: event.value || null,
        anchor_point: event.anchor.anchor_point,
        anchor_offset_type: event.anchor.offset_type,
        anchor_offset_value: event.anchor.offset_value,
    }));
}
